import { renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" default body ")
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" default footer ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header")
        ]),
        _createVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "body", {}, () => [
            _hoisted_6
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _hoisted_8,
            _createVNode("button", {
              class: "modal-button-ok",
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.toggleActive(...args)))
            }, " OK ")
          ])
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.active]
  ])
}